<template>
	<div class="wrapper">
		<headerTag />
			<p class="userIn1" style="margin-top: 6.15rem;">
				<input type="text" placeholder="账户名" autocomplete="off" v-model="loginName" maxlength="20" />
				<img src="../../assets/images/user/user1.png" alt="" />
			</p>
			<p class="userIn1">
				<input type="password" placeholder="密码" autocomplete="off" v-model="pwd" maxlength="20" />
				<img src="../../assets/images/user/password1.png" alt="" class="passwordImg" />
			</p>
			<p class="userIn1">
				<input type="number" placeholder="手机号" autocomplete="off" v-model="mobile" onkeyup="this.value=this.value.replace(/[^\d\.]/g,'')" oninput="if(value.length>11)value=value.slice(0,11)" />
				<img src="../../assets/images/user/phone1.png" alt="" />
			</p>
			<p class="userIn1" style="margin-bottom: 0;">
				<input type="text" placeholder="验证码" style="width: 68%;" maxlength="6" v-model="dxCodeNum" autocomplete="off"onkeyup="this.value=this.value.replace(/[^\d\.]/g,'')" />
				<button class="getCode" @click="getcodeFuc" id="getCode">{{getCodeNum}}</button>
			</p>
			<button class="userBtn1" id="registerBtn" @click="registerBtn">注册</button>
			<p class="getRule">
				注册即代表同意 <router-link :to="{ name:'agreement' }">《零分享服务协议》</router-link>
			</p>
	</div>

</template>

<script>
   
    import "../../assets/css/user.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
	import {VidateUtil} from '../../assets/js/validate.js'
	import {sendSms,phoneSeconds} from '../../assets/js/smsUtil.js'
	import {Decrypt,Encrypt} from '../../assets/js/aes/cryptoUtil.js'
	import { Dialog,Toast } from 'vant'

	export default {
		name: 'registerPage',
		data(){
		  return {
			loginName:'',//账户名
			pwd:'',//密码
			mobile:'', //手机号
			getCodeNum:'获取验证码',//获取短信验证码按钮
			dxCodeNum:'',//用户填的短信验证码
		  }
		},
		methods:{
			registerBtn(){
				 if (this.loginName.length < 2 || this.loginName.length > 20) {
				       this.$message.error({message: '账户名长度为2-20位'});
				        return;
				  }
				  if (!VidateUtil.checkUserName(this.loginName)) {
				        this.$message.error({message: '账户名不能有特殊字符'});
				        return;
				  }
				  if (this.pwd == "" || this.pwd == null) {
				        this.$message.error({message: '密码不能为空'});
				        return;
				   }
				  
				  if (this.pwd.length < 8 || this.pwd.length > 20) {
				        this.$message.error({message: '密码长度为8-20位'});
				        return;
				   }
				  
				  if(!VidateUtil.checkPassword(this.pwd)){
						this.$message.error({message: '密码格式不正确'});
						return;
				  } 
				  if (this.mobile == "" || this.mobile == null) {
				         this.$message.error({message: '手机号不能为空'});
				         return;
				   }
				  if(!/^1[3456789]\d{9}$/.test(this.mobile)) {
				  		this.$message.error({message: '手机号输入不正确'});
				  		return;
				  } 
				  if (this.dxCodeNum == "" || this.dxCodeNum == null) {
				          this.$message.error({message: '验证码不能为空'});
				          return;
				   }
				   if (this.dxCodeNum.length != 6) {
				          this.$message.error({message: '验证码输入不正确'});
				          return;
				    }
					this.registUser();
					
			},
			registUser() {
				this.axios({
				    method: 'POST',
				    url:'/user/registUser',
					params:{
					  loginName: this.loginName,
					  pwd:this.pwd,
					  mobile: this.mobile,
					  smsCode:this.dxCodeNum,
					}
				}).then((res)=>{
						if(res.data.code==1000){
							Dialog.alert({
							 message: '恭喜您注册成功，请前往登录页面'
						   }).then(() => {
							 this.$router.push({ name:'loginPage' });
						   });
						}else if(res.data.code==4008){
							 this.$message.error({message: '账户名不得为空'});
						}else if(res.data.code==4011){
							 this.$message.error({message: '账户名长度限制2~20个字数'});
						}else if(res.data.code==4009){
							 this.$message.error({message: '该账户名已存在'});
						}else if(res.data.code==4001){
							 this.$message.error({message: '手机号不得为空'});
						}else if(res.data.code==4002){
							 this.$message.error({message: '请您输入正确的手机号'});
						}else if(res.data.code==4003){
							 this.$message.error({message: '该手机号已存在'});
						}else if(res.data.code==4010){
							 this.$message.error({message: '密码不得为空'});
						}else if(res.data.code==1103){
							 this.$message.error({message: '登录密码格式有误,请重新输入'});
						}else if(res.data.code==4012){
							 this.$message.error({message: '密码长度限制8~20个字数且不支持空格'});
						}else if(res.data.code==4004){
							 this.$message.error({message: '请您输入正确的验证码'});
						}else if(res.data.code==2103){
							 this.$message.error({message: '验证码已失效，请重新发送验证码'});
						}else if(res.data.code==2104){
							 this.$message.error({message: '手机验证码输入有误，请重新填写'});
						}else{
							 this.$message.error({message: '网络异常，请稍后重试'});
						}
				}).catch((err)=>{
				    this.$message.error({message: '网络异常，请稍后重试'});
				})
			},
			getcodeFuc(){//获取短信验证码
			
				this.validatePhone();
				let mobile=Encrypt(this.mobile);
				let _this=this;
				sendSms(1,mobile,function(data){//1:注册手机验证码
					if(data.code == 1000){
						//短信发送成功，弹出提示框
						_this.$toast("已发送验证码到您的手机，请注意查收");
						phoneSeconds(); //倒计时
						
					}else if(data.code == 2105){
						_this.$message.error({message: '该手机号已被注册'});
					}else{
						_this.$message.error({message: data.message});
					}
				},(errorback)=>{
					//回调错误信息
					_this.$message.error({message: errorback});
				});
				
			},
			validatePhone(mobile){
			   //判断输入的手机号是否合法
			   if(this.mobile=='') {
					this.$message.error({message: '手机号码不能为空'});
					return false;
				} else if(!/^1[3456789]\d{9}$/.test(this.mobile)) {
					this.$message.error({message: '请输入正确的手机号'});
					return false;
			   } 
			}, 
			
		},
		components: {
			headerTag,
			VidateUtil,
			sendSms,
			phoneSeconds,
		},
	}

</script>